import { useMatch } from "react-router-dom";
import { skeletonize } from "../../helpers/skeletonize";
import { Body } from "../body/Body";
import { BorderBar, Content } from "../tab/Tab.Parts";
import { Props, SkeletonTab } from "./NavTab.Parts";

const BodySkeleton = skeletonize(Body);

export const NavTabSkeleton = ({ label = "", ...props }: Props) => {
  const pathname = props.to.toString().split("?")[0];
  const match = useMatch(pathname);
  const isActive = !!match;

  return (
    <SkeletonTab $noWrap={props.$noWrap}>
      <Content>
        <BodySkeleton variant="normal-strong">{label}</BodySkeleton>
      </Content>
      <BorderBar $active={isActive} />
    </SkeletonTab>
  );
};
